import React from 'react';
import { useLoadingStyle } from '@/hooks/useLoadingStyle';

const LOGO_URL = '/lovable-uploads/f6cd4aef-9488-423f-83b9-406abaa28823.png';

const Loading = () => {
  const style = useLoadingStyle();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background z-50">
      {style === 'pulse' && (
        <div className="flex flex-col items-center gap-4">
          <img src={LOGO_URL} alt="PT. Gemilang Cipta Wawasan" className="w-24 h-24 object-contain animate-pulse" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      )}

      {style === 'bounce' && (
        <div className="flex flex-col items-center">
          <img 
            src={LOGO_URL} 
            alt="PT. Gemilang Cipta Wawasan"
            className="w-24 h-24 object-contain"
            style={{ animation: 'loading-bounce 1s ease-in-out infinite' }}
          />
        </div>
      )}

      {style === 'spinner' && (
        <div className="flex flex-col items-center gap-4">
          <div className="relative flex items-center justify-center">
            <div 
              className="w-28 h-28 rounded-full border-4 border-muted border-t-primary"
              style={{ animation: 'loading-spin 0.8s linear infinite' }}
            />
            <img src={LOGO_URL} alt="PT. Gemilang Cipta Wawasan" className="absolute w-16 h-16 object-contain" />
          </div>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      )}

      {style === 'dots' && (
        <div className="flex flex-col items-center gap-4">
          <img src={LOGO_URL} alt="PT. Gemilang Cipta Wawasan" className="w-24 h-24 object-contain" />
          <div className="flex gap-2">
            {[0, 1, 2].map(i => (
              <div 
                key={i}
                className="w-3 h-3 rounded-full bg-primary"
                style={{ animation: `loading-dots 1.2s ease-in-out ${i * 0.2}s infinite` }}
              />
            ))}
          </div>
        </div>
      )}

      {style === 'skeleton' && (
        <div className="flex flex-col items-center gap-5">
          <img src={LOGO_URL} alt="PT. Gemilang Cipta Wawasan" className="w-24 h-24 object-contain" />
          <div className="w-48 h-2 rounded-full bg-muted overflow-hidden">
            <div 
              className="h-full rounded-full bg-primary"
              style={{ animation: 'loading-progress 1.5s ease-in-out infinite', width: '40%' }}
            />
          </div>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      )}

      {style === 'wave' && (
        <div className="flex flex-col items-center gap-4">
          <div className="relative flex items-center justify-center w-32 h-32">
            <div 
              className="absolute w-28 h-28 rounded-full border-2 border-primary/30"
              style={{ animation: 'loading-ripple 1.5s ease-out infinite' }}
            />
            <div 
              className="absolute w-28 h-28 rounded-full border-2 border-primary/20"
              style={{ animation: 'loading-ripple 1.5s ease-out 0.5s infinite' }}
            />
            <div 
              className="absolute w-28 h-28 rounded-full border-2 border-primary/10"
              style={{ animation: 'loading-ripple 1.5s ease-out 1s infinite' }}
            />
            <img src={LOGO_URL} alt="PT. Gemilang Cipta Wawasan" className="w-16 h-16 object-contain relative z-10" />
          </div>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      )}
    </div>
  );
};

export default Loading;
